module.exports = __webpack_public_path__ + "static/media/cards-mobile.cd5f2245.png";